import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableMissionTypeForm_GroupingMode_Switch_Mutation = graphql(`
  mutation ResolvableMissionTypeForm_GroupingMode_Switch(
    $groupingMode: GroupingModeEnum!
    $label: String
    $serviceUserId: Id!
    $versionData: VersionDataInput
  ) {
    switchResolvableMissionTypeGroupingMode(
      groupingMode: $groupingMode
      label: $label
      serviceUserId: $serviceUserId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useSwitchResolvableMissionTypeGroupingModeMutation = () =>
  useGraphQLMutation(ResolvableMissionTypeForm_GroupingMode_Switch_Mutation);
